module.exports = __webpack_public_path__ + "img/hyper-magnetism-ring.92e3d087.png";